/**
 * Label Component
 *
 * A form label component with proper accessibility.
 */

import * as React from 'react';
import { cn } from '@utils/cn';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  /**
   * Additional class names
   */
  className?: string;
  /**
   * Children to render
   */
  children?: React.ReactNode;
}

/**
 * Label Component
 *
 * Provides a styled label for form inputs.
 */
export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          className
        )}
        {...props}
      >
        {children}
      </label>
    );
  }
);

Label.displayName = 'Label';
